export default "<div container>\r\n  <h4 title>{{ title }}</h4>\r\n  <ng-content></ng-content>\r\n</div>";